<template>
  <component 
    :is="componentType"
    v-bind="getAttrs()"
    v-model.trim="model[def.name]"
    v-on="getListeners()"
  ></component>
</template>

<script>

// import AppFileInput from "@/components/library/inputFields/AppFileInput";

export default {
  name: "AbrFormPropField",
  props: ["def", "model"],
  computed: {
    componentType() {
      const type = this.def.inputType?.name.split(".").pop()	;
      switch (type) {
        case "itTextArea":
          return () => import("@/components/library/inputFields/AppTextArea");
        case "itExtText":
          return () => import("@/components/library/inputFields/AppExtTextField");
        case "itTime":
          return () => import("@/components/library/inputFields/AppTimePicker");
        case "itMoney":
          return () => import("@/components/library/inputFields/AppMoneyField.vue");
        case "itPercent":
          return () => import("@/components/library/inputFields/AppMoneyField");
        case "itText":
            if(this.def.displayConvertType)
              return () => import("@/components/library/inputFields/AppConverterTextField");
						return () => import("@/components/library/inputFields/AppTextField");
        case "itGlobalDate":
          return () => import("@/components/library/inputFields/AppDatePicker");
        case "itLocalDate":
          return () => import("@/components/library/inputFields/AppDatePicker");
        case "itDateAndTime":
          return () => import("@/components/library/inputFields/AppDateAndTimePicker");
        case "itFileField":
          return () => import("@/components/library/inputFields/AppFileUpload")
        case "itFileArea":
          return () => import("@/components/library/inputFields/AppFileUpload")
        case "itFile":
          return () => import("@/components/library/inputFields/AppFileInput")
        default:
          return () => import("@/components/library/inputFields/AppTextField");
      }
    },
  },
  methods: {
		getAttrs() {
      const attrs = { ...this.$attrs, ...this._props };
      const type = this.def.inputType?.name.split(".").pop();
      //get locale param from vuex store
      const lang = this.$store.state.locale === 'fa-IR' ? 'fa' : 'en';
      switch (type) {
        case "itTextArea":
          return attrs;
        case "itExtText":
          return attrs;
        case "itTime":
          return attrs;
        case "itMoney":
          return attrs;
        case "itPercent":
          return attrs
        case "itText":
          return attrs;
        case "itGlobalDate":
          return {...attrs , locale : "en"};
        case "itLocalDate":
          return {...attrs , locale : lang};
        case "itDateAndTime":
          return {...attrs , locale : lang};
        default:
          return attrs;
      }
    },
    getListeners() {
      const listeners = this.$listeners;
      const type = this.def.inputType?.name.split(".").pop();
      switch (type) {
        case "itTextArea":
          return listeners;
        case "itExtText":
          return listeners;
        case "itTime":
          return listeners
        case "itMoney":
          return listeners;
        case "itPercent":
          return listeners
        case "itText":
          return listeners;
        case "itGlobalDate":
          return listeners;
        case "itLocalDate":
          return listeners;
        case "itFileUpload":
          return listeners;
        default:
          return listeners;
      }
    },
	},
}
    
</script>
